export const QUEST_ITEM_COMPLETE = 'quest_item_complete'
export const QUEST_COMPLETE = 'quest_complete'
export const QUEST_START = 'quest_start'
export const QUEST_CLOSE = 'quest_close'
